<mat-list-item class="table-type">
  <div class="index m-2">[{{order}}]</div>
  <div class="fieldName m-2">{{attribute.attr.name}}:</div>
  <div class="value m-2">
    <div class="table-container">
      <table mat-table [dataSource]="attrTableSource" class="mat-elevation-z8">
        <ng-container matColumnDef="oneindex">
          <th mat-header-cell *matHeaderCellDef> # </th>
          <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
        </ng-container>

        <ng-container [matColumnDef]="colOpt.name" *ngFor="let colOpt of columnOpts">
          <th mat-header-cell *matHeaderCellDef> {{colOpt.friendlyName}} </th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{element[colOpt.name]}}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
        <tr mat-row *matRowDef="let row; columns: columnNames; let i = index"></tr>
      </table>
    </div>
  </div>
</mat-list-item>

